angular.module('lf.common')

.factory('redeemService', function ($http) {
  return {
    submitRedeemCode: function (params) {
      return $http({
        method: 'POST',
        url: params.url,
        data: params.serializedData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
    }
  }
});
